export { default as CarrierListTemplate } from './CarrierListTemplate';
export { default as CarrierEditTemplate } from './CarrierEditTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/carrier/pages/index.js